// extracted by mini-css-extract-plugin
export var $animation_name = "Logo-module--$animation_name--7f585";
export var Logo = "Logo-module--Logo--a0137";